import { AxiosError } from 'axios';

export function isEmpty(value: unknown) {
  return (
    value == null ||
    (typeof value === 'boolean' && value === false) ||
    (typeof value === 'string' && value === '') ||
    (typeof value === 'number' && value <= 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (Array.isArray(value) && value.length === 0)
  );
}
export function isNotEmpty(value: unknown) {
  return !isEmpty(value);
}

export const formatAPIKey = (apiKey: string) => {
  return `${apiKey.slice(0, 10)}...${apiKey.slice(-6)}`;
};

export const handleMessageError = (error: unknown) => {
  if (error instanceof AxiosError) {
    if (error.response?.data?.details) {
      return error.response?.data?.details;
    }
    return error.message;
  } else if (error instanceof Error) {
    return error.message;
  }
  return 'Something went wrong.';
};

export const toBase64 = (str: string) => {
  return btoa(
    encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
      }
    )
  );
};
